export default function Containers({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
      <path fill="#969faa" d="M62 6H6a4 4 0 0 1 4-4h48a4 4 0 0 1 4 4z" />
      <path fill="#ff826e" d="M46 10h16v40H46zM10 10h22v40H10z" />
      <path
        fill="#aab2bd"
        d="M46 50h16a4 4 0 0 1-4 4H46zM46 54H22v-4h10zM46 6l-14 4H10v36H6V6zM46 6h16v4H46z"
      />
      <path fill="#ccd1d9" d="M46 16v38l-14-4V10l14-4v4z" />
      <path
        fill="#fc6e51"
        d="M50 16v28c0 1.1-.9 2-2 2s-2-.9-2-2V16c0-1.1.9-2 2-2 .55 0 1.05.22 1.41.59.37.36.59.86.59 1.41zM58 16v28c0 1.1-.9 2-2 2s-2-.9-2-2V16c0-1.1.9-2 2-2 .55 0 1.05.22 1.41.59.37.36.59.86.59 1.41z"
      />
      <path
        fill="#dfb28b"
        d="M30 26H18a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zM30 38H18a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zM24 50H12a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2z"
      />
      <path
        fill="#d3a06c"
        d="M20 46H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h16a2 2 0 0 0 2-2V48a2 2 0 0 0-2-2zM22 14h4v4h-4zM22 26h4v4h-4zM20 38v4h-4v-4h2z"
      />
      <path fill="#b27946" d="M12 52H8v-6h8v6z" />
      <path d="M58 1H10a5 5 0 0 0-5 5v39H4a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-5h35a5 5 0 0 0 5-5V6a5 5 0 0 0-5-5zM47 49v-2.18A2.97 2.97 0 0 0 51 44V16a3 3 0 0 0-4-2.82V11h14v38zm-16 0h-4.18c.1-.31.18-.65.18-1v-8c0-.35-.07-.69-.18-1H30c.35 0 .69-.07 1-.18zm-11-4h-9v-5a1 1 0 0 1 1-1h3v4h6v-4h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-1v-1a3 3 0 0 0-3-3zm-9 4v2H9v-4h6v4h-2v-2zm13-12h-6a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3v4h6v-4h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1zm-7-13v-8a1 1 0 0 1 1-1h3v4h6v-4h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H18a1 1 0 0 1-1-1zm6-9h2v2h-2zm0 12h2v2h-2zm-6 12h2v2h-2zm14-25.82a2.97 2.97 0 0 0-1-.18H18a3 3 0 0 0-3 3v8c0 .77.3 1.47.78 2a2.98 2.98 0 0 0-.78 2v8c0 .35.07.69.18 1H12c-.35 0-.69.07-1 .18V11h20zM33 36V10.75l12-3.43v45.35l-12-3.42zm14-20a1 1 0 0 1 2 0v28a1 1 0 0 1-2 0zm0-7V7h14v2zM10 3h48a3 3 0 0 1 2.82 2H7.18A3 3 0 0 1 10 3zM7 7h31.86l-7 2H9v36H7zm14 53a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V48a1 1 0 0 1 1-1h3v6h10v-6h3a1 1 0 0 1 1 1zm2-9h8.86l7 2H23zm35 2H47v-2h13.82A3 3 0 0 1 58 53z" />
      <path d="M56 13a3 3 0 0 0-3 3v28a3 3 0 0 0 6 0V16a3 3 0 0 0-3-3zm1 31a1 1 0 0 1-2 0V16a1 1 0 0 1 2 0z" />
    </svg>
  );
}
